import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const fetchMaintenanceMode = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('system_settings')
        .select('setting_value')
        .eq('setting_key', 'maintenance_mode')
        .is('project_id', null)
        .maybeSingle();

      if (error) {
        console.error('Error fetching maintenance mode:', error);
        setIsMaintenanceMode(true);
      } else if (data) {
        setIsMaintenanceMode(data.setting_value === true || data.setting_value === 'true');
      } else {
        // No setting found = default to maintenance mode
        setIsMaintenanceMode(true);
      }
    } catch (err) {
      console.error('Error:', err);
      setIsMaintenanceMode(true);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const toggleMaintenanceMode = async (value: boolean) => {
    try {
      // Check if setting exists
      const { data: existing } = await supabase
        .from('system_settings')
        .select('id')
        .eq('setting_key', 'maintenance_mode')
        .is('project_id', null)
        .maybeSingle();

      if (existing) {
        const { error } = await supabase
          .from('system_settings')
          .update({ setting_value: value })
          .eq('id', existing.id);
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('system_settings')
          .insert({
            setting_key: 'maintenance_mode',
            setting_value: value,
            project_id: null,
          });
        if (error) throw error;
      }

      setIsMaintenanceMode(value);
    } catch (err) {
      console.error('Error toggling maintenance mode:', err);
    }
  };

  useEffect(() => {
    fetchMaintenanceMode();
  }, [fetchMaintenanceMode]);

  return { isMaintenanceMode, isLoading, toggleMaintenanceMode, refetch: fetchMaintenanceMode };
};
